module.exports = __webpack_public_path__ + "static/04-a455938ea82c1ca2da81745ba006c25b.jpg";